class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    // Save product id in sessionStorage when product card is clicked
    this.productsWrapper = this.querySelector('[data-products-wrapper]') || false;

    if (this.productsWrapper) this.handleProductClicks(this.productsWrapper);
    if (this.productsWrapper) this.handleQuickShop(this.productsWrapper);

    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');

    // When back button of the browser is clicked, scroll back to the position where you left it
    this.handleBackButtonBrowser();

  }


  /**
   * handleBackButtonBrowser
   * @description When you came back to the collection page by clicking the back button of the browser, then scroll back to the position where you left it
   */
  handleBackButtonBrowser() {
    if (!window.performance && !window.performance.getEntriesByType('navigation')) {
      return false;
    }

    // check if you came to the collection page by the clicking the back button in the browser
    const entries = window.performance.getEntriesByType('navigation');

    if (entries.length > 0 && entries[0].type === 'back_forward') {

      // get product card id from session storage
      const productId = sessionStorage.getItem('historyProductId');

      // find the product card element
      const productElem = document.querySelector('[data-id="' + productId + '"]') || false;

      if (productElem) {

        // Reset the scroll location of the page
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

        // calculate vertical offset
        const reviewsBar = document.querySelector('.reviews-io-rating-bar-widget') || false;
        const announcementBar = document.querySelector('.announcement-bar') || false;
        const header = document.querySelector('#header') || false;

        const heightReviewsBar = reviewsBar ? reviewsBar.getBoundingClientRect().height : 0;
        const heightAnnouncementBar = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
        const heightHeader = header ? header.getBoundingClientRect().height : 0;

        const verticalOffset = heightHeader + heightAnnouncementBar + heightReviewsBar;

        // scroll to product element
        window.scrollTo({
          top: window.scrollY + productElem.getBoundingClientRect().top - verticalOffset
        });

        // reset session storage
        sessionStorage.removeItem('historyProductId');

      }

    }
  }


  /**
   * handleQuickShop
   * @description Quickshop function
   */
  handleQuickShop(productsWrapper) {
    let quickShopArr = productsWrapper.querySelectorAll('[data-quickshop-trigger]');
    quickShopArr.forEach((button) => {
      button.addEventListener('click', this.open.bind(this));
      button.closest('[data-product-card]').addEventListener('mouseleave', this.close.bind(this));
    })
  }

  /**
   * open
   * @description Quickshop open
   */
  open(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentQuickShop = event.target.closest('[data-quickshop]');

    currentQuickShop.querySelector('[data-quickshop-variant]').classList.add('is-open');
    currentQuickShop.querySelector('[data-quickshop-bg]').classList.add('is-open');
    currentQuickShop.classList.add('is-open');

    currentQuickShop.querySelector('[data-quickshop-close]').addEventListener('click', this.close.bind(this))

    currentQuickShop.querySelectorAll('[data-variant-id]').forEach((variant) => {
      // don't add product to the cart if the product is sold out
      if (variant.hasAttribute('data-quick-variant-sold-out')) return;

      variant.addEventListener('click', this.addVariant.bind(this));
    })

    currentQuickShop.querySelector('[data-quickshop-bg]').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.close(event);
    });
  }

  /**
   * addVariant
   * @description Add Variant to the cart
   */
  addVariant(event) {
    event.preventDefault();
    event.stopPropagation();
    let variantId = event.target.dataset.variantId;

    let items = [];

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let cartDrawerFetch = [];
    if (this.cartDrawer) {
      cartDrawerFetch = this.cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    const sectionsToFetch  = [
      cartDrawerFetch,
      ...this.cartNotification.getSectionsToRender().map((section) => section.id)
    ];

    let object = {
      quantity: 1,
      id: parseFloat(variantId),
      sections: sectionsToFetch,
      sections_url: window.location.pathname
    }
    items.push(object);

    let body = JSON.stringify({
      items: items
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((parsedState) => {

      // When quantity error
      if (parsedState.status == 422 && this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
        return;
      }

      if (this.cartDrawer) {
        this.renderContents(parsedState);
        this.cartDrawer.renderContents(parsedState);
        this.cartDrawer.open();
      }

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      event.target.closest('[data-quickshop]').classList.remove('is-open');
      event.target.closest('[data-quickshop]').querySelector('[data-quickshop-variant]').classList.remove('is-open');
      event.target.closest('[data-quickshop]').querySelector('[data-quickshop-bg]').classList.remove('is-open');
    });
  }


  /**
   * close
   * @description Quickshop close
   */
  close(event) {
    event.preventDefault();
    event.stopPropagation();

    // set the event target to be the Quickshop wrapper, even when the mouse leave event is triggered from the product card
    const quickshop = event.target.hasAttribute('data-product-card') ? event.target.querySelector('[data-quickshop]') : event.target.closest('[data-quickshop]');

    quickshop.querySelector('[data-quickshop-variant]').classList.remove('is-open');
    quickshop.querySelector('[data-quickshop-bg]').classList.remove('is-open');
    quickshop.classList.remove('is-open');
  }

  /**
   * handleProductClicks
   * @description On product click we get the product id and save it in sessionStorage
  */
  handleProductClicks(productsWrapper) {

    if (!productsWrapper) {
      return false;
    }

    // get all product cards
    productsWrapper.querySelectorAll('[data-product-card]').forEach(product => {

      // listen for click on product card
      product.addEventListener('click', (e) => {

        e.preventDefault();
        e.stopPropagation();

        // check if we have a product card and id
        const productCard = e.currentTarget || false;
        if (!productCard && !productCard.id ) {
          return false;
        }
        sessionStorage.setItem('historyProductId', productCard.id);

        // go to the product page (unless the target is a Sold out variant in the quick shop)
        if (e.target.hasAttribute('data-quick-variant-sold-out')) return;

        let newHref = e.target.href;
        if (typeof newHref === 'undefined') {
          newHref = e.target.closest('[data-product-card]').querySelector('a').href;
        }
        location.href = newHref;
      });
    });
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid);
}
